module.exports = {
  services: {
    badge: "Services",
    title: "Services",
    subtitle: "Minimal services page.",
    summaryTitle: "What is here",
    summaryText: "You can extend this section with cases and blocks later.",
    summaryPoints: ["Audit", "Support", "Integrations"],
    cardsTitle: "Directions",
    cardsSubtitle: "Data is rendered from card arrays.",
    cards: [
      { icon: "fas fa-network-wired", title: "Networks", text: "Short description." },
      { icon: "fas fa-cloud", title: "Cloud", text: "Short description." },
      { icon: "fas fa-user-shield", title: "Security", text: "Short description." }
    ],
    listTitle: "Work format",
    listSubtitle: "Points can be added or removed easily.",
    listItems: ["Support", "Implementation", "Maintenance"],
    stats: [
      { value: "3", label: "support lines" },
      { value: "24/7", label: "availability" }
    ],
    ctaTitle: "Need consultation?",
    ctaText: "Minimal placeholder for the services section.",
    primaryHref: "/pages/contact",
    primaryLabel: "Contact us",
    secondaryHref: "/pages/portal",
    secondaryLabel: "Portal",
    processTitle: "",
    processSubtitle: "",
    process: [
      { num: "01", icon: "fas fa-search", title: "", text: "" },
      { num: "02", icon: "fas fa-drafting-compass", title: "", text: "" },
      { num: "03", icon: "fas fa-cogs", title: "", text: "" },
      { num: "04", icon: "fas fa-check-circle", title: "", text: "" }
    ]
  }
};